import { makeObservable, observable } from "mobx";
import { createModelSchema, object, optional, primitive } from "serializr";
import { CancelReason } from "./CancelReason";

export class JobCancellation {
  reason = new CancelReason();
  note = '';

  constructor() {
    makeObservable(this, {
      reason: observable,
      note: observable
    });
  }
}

createModelSchema(JobCancellation, {
  reason: optional(object(CancelReason)),
  note: optional(primitive())
});
